import React from 'react'
import axios from 'axios';
import { Breadcrumbs } from "@material-tailwind/react";
import { Link, useNavigate } from 'react-router-dom'
import { MdOutlineAddPhotoAlternate } from "react-icons/md";
import { MdOutlineHomeWork } from "react-icons/md";
import { IoMdPin, IoIosMail } from "react-icons/io";
import { AiOutlineEdit } from "react-icons/ai";
import { useState, useEffect } from 'react';
import Loading from '../../../COMPONENTS/Loading/Loading'
import { GoArrowLeft } from "react-icons/go";
import SidebarTop from '../../SidebarTop';
import { MdOutlinePayment } from "react-icons/md";
import Loisirs from "../../../../API/tourisme/loisir/index"
import { ToastContainer, toast } from "react-toastify"
import { FaPhoneAlt } from 'react-icons/fa';
import { CiCalendarDate } from "react-icons/ci";
import { GiMoneyStack } from "react-icons/gi";
import { styled } from '@mui/material/styles';
import { FedaCheckoutButton, FedaCheckoutContainer } from 'fedapay-reactjs';
import {Button,Form } from 'react-bootstrap';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { loadStripe } from '@stripe/stripe-js';
import { getPaymentStatus } from '../../../../API/stripe/StripeTranction';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import Create from '../../../../Payment/Create';


function AjoutLoisir() {

    localStorage.setItem('url', JSON.stringify('/Dashboard/Publications/Loisirs_activites/Ajouter_les_activites'));

    const navigate = useNavigate();

    const [data, setData] = useState(() => {
        // getting stored value
        const saved = localStorage.getItem("data");
        const initialValue = saved !== null ? JSON.parse(saved) : null;
        return initialValue;
    });

    const [formData, setFormData] = useState(
        JSON.parse(localStorage.getItem('formData')) || {}
    );
    const [priceD, setPriceD] = useState(null);
    const [cities, setCities] = useState([]);
    const [countries, setCountries] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [address, setAddress] = useState([]);
    const [pricePub, setPricePub] = useState();
    const [open,setOpen] = useState(false);
    const [options, setOptions] = useState(null);
    const [curr,setCurr] = useState();
    
    
    let fd = new FormData();

   

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });

         // Enregistrez l'état du formulaire dans le stockage local
        localStorage.setItem('formData', JSON.stringify(
            {...formData,[event.target.name]: event.target.value,}
        ));
  
    };


    const handleCountryChange = (selectedOption) => {
       
        localStorage.setItem('code', selectedOption.value);  
        setFormData({ ...formData, country: selectedOption.value });  
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${selectedOption.value}`)
            .then(response => {
                setProvinces(response.data.data)
            })
            .catch(err => console.log(err));
    };

    const handleProvinceChange = (selectedProvince) => {
        // console.log(selectedProvince)
         //const { value } = selectedProvince.value;
         localStorage.setItem('province',selectedProvince.value)
         setFormData({ ...formData, province: selectedProvince.value });
     
         // city
         axios.get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${selectedProvince.value}`)
             .then(response => {
                 setCities(response.data.data);
             })
             .catch(err => console.log(err));
     };

     const handleCityChange = (selectedCity)=>{
        localStorage.setItem('ville',selectedCity.value)
        setFormData({ ...formData, ville: selectedCity.value });
   }

    //Récuppérer le prix de publication
    const getPricePub = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/pub/loisirs`);
        setPricePub(res.data.data.Prices);
        localStorage.setItem('pricePub', res.data.data.Prices);
      } catch (err) {
        console.log(err);
      }
    };

    const getPriceDollar = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/dollar`);
          //console.log(res.data.data.value_to_xof);
          setPriceD(res.data.data.value_to_xof);
        } catch (err) {
          console.log(err);
        }
    };
    
    const [loading, setLoading] = useState(true);

    // États pour gérer le formulaire et le popup
    const [showPopup, setShowPopup] = useState(false);
     const [errors,setErrors] = useState({})


     useEffect(()=>{
        if(data !== null)
        {
              //adresse
                axios.get(`${process.env.REACT_APP_BASE_URL}/api/utilisateur/adresse/${data?.azId}`)
                .then(response => {
                setAddress(response.data.data)
                })
                .catch(err => console.log(err))
        }else{
             navigate('/Connexion')
             return;
        }
      
   },[data?.azId])

    useEffect(() => {
           if (address && address.Adresses) {
             fd.append("adresse",address.Adresses)      
           }
    }, [address]);


    let totalPaid = (parseFloat(pricePub) * Math.ceil((new Date(formData.date_fin) - new Date(formData.date_debut))/ (1000 * 60 * 60 * 24)))
    if(totalPaid > 0)
    {
        localStorage.setItem('montant',totalPaid)
    }

    const verifyLoisirFormSubmit = ()=>{
        fd.append("nom", formData.nom ? formData.nom : "");
        fd.append("user", data.userId ? data.userId  : "");
        fd.append("desc", formData.msg ? formData.msg : "");
        fd.append("prix", formData.tarif ? formData.tarif : "");

        fd.append("date_debut", formData.date_debut ? formData.date_debut : "" );
        fd.append("date_fin", formData.date_fin ? formData.date_fin : "");

        fd.append("adresse", formData.lieu ? formData.lieu : address.Adresses);
        fd.append("mail", formData.mail ? formData.mail : data.userMail);
        fd.append("tel", formData.phone ? formData.phone : data.userTel);
        fd.append("pays", formData.country ? formData.country : "");
        fd.append("ville", formData.ville ? formData.ville : "");
        fd.append("province", formData.province ? formData.province : "");
        for(let i = 0; i < document.getElementById("photo")?.files.length; i++){
            fd.append("photo[]", document.getElementById("photo")?.files[i]);
        }

        Loisirs.verifyLoisirForm(fd).then((res)=>{
              if(res.data.status === 422){
                    setErrors(res.data.errors)
                    setOpen(false)
              }else{
                if(totalPaid === 0)
                {
                    submitForm();
                    navigate("/Dashboard/Publications/Loisirs_activites/Voir_des_activites");
                    return;
                }
                setOpen(!open)
                //setShowPopup(!showPopup)
             }
        }).catch((err)=>{
            console.log("Erreur lors de l'appel a l'API ",err)
        }).finally(()=>{
            setLoading(false)
        })
    } 

    const submitForm = (provider,paymentId,currencyId) => {
        //event.preventDefault();
       
        const pricePubFromStorage = localStorage.getItem('pricePub');

        fd.append("nom", formData.nom ? formData.nom : "");
        fd.append("user", data.userId ? data.userId  : "");
        fd.append("desc", formData.msg ? formData.msg : "");
        fd.append("prix", formData.tarif ? formData.tarif : "");

        fd.append("date_debut", formData.date_debut ? formData.date_debut : "" );
        fd.append("date_fin", formData.date_fin ? formData.date_fin : "");

        fd.append("adresse", formData.lieu ? formData.lieu : address.Adresses);
        fd.append("mail", formData.mail ? formData.mail : data.userMail);
        fd.append("tel", formData.phone ? formData.phone : data.userTel);
        fd.append("pays", formData.country ? formData.country : "");
        fd.append("ville", formData.ville ? formData.ville : "");
        fd.append("province", formData.province ? formData.province : "");

        if (formData.date_debut && pricePubFromStorage && formData.date_fin) {
            const days = Math.ceil((new Date(formData.date_fin) - new Date(formData.date_debut)) / (1000 * 60 * 60 * 24));
            const montant = parseFloat(pricePubFromStorage) * days;
            fd.append("montant", montant);

        } else {
            toast.error("Veuillez remplir tous les champs");
            return;
        }

        for(let i = 0; i < document.getElementById("photo")?.files.length; i++){
            fd.append("photo[]", document.getElementById("photo")?.files[i]);
        }
        setLoading(true)
        Loisirs.submitForm(fd)
            .then((res) => {
                if (res.data.status === 201) {
                    if(provider !== null && paymentId !== null && currencyId !== null){
                         const formD = {
                                  userId:data.azId,
                                  montant:totalPaid,
                                  provider: provider,
                                  payement_id:paymentId ,
                                  currency:currencyId,
                                  annonce_number: res.data.announce_number,
                                  description:"Transaction d'ajout  d'un loisir"
                              }
                         axios.post(`${process.env.REACT_APP_BASE_URL}/api/store/rechargement-paiememnt`,formD)
                                .then((res)=>{
                                if(res.data.status === 200){
                                //toast.success(res.data.message);
                                //console.log("enregistrement reussie")
                                }
                                }).catch((err)=>{
                                console.log("Erreur lors de l'appel a l'API ",err)
                                })
                    }
                    localStorage.removeItem('formData');
                    localStorage.removeItem('pricePub');
                    localStorage.removeItem('province');
                    localStorage.removeItem('ville')
                    localStorage.setItem('message',res.data.message)
                    //localStorage.setItem('idannonce',res.data.announce_number)
                    setErrors({})
                    navigate("/Dashboard/Publications/Loisirs_activites/Voir_des_activites");
                    return
                   //console.log(res);
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                toast.error('Erreur merci de reessayer !');
                console.log(err);
            })
            .finally(() => {
                setLoading(false);
            })
    };

     // Fonction de gestion de la soumission du formulaire
    const handleSubmit = (event) => {
        event.preventDefault();
        verifyLoisirFormSubmit()
    };

  
    useEffect(() => {

        if (!data) {
            navigate("/Connexion");
        }

        
         // Appel API pour récupérer la monnaie
           axios
            .get(`${process.env.REACT_APP_BASE_URL}/api/get/info/website`)
            .then((res) => {
            if (res.data.status === 200 ) {
                setCurr(res.data.currency);
                localStorage.setItem('id_currency', res.data.currency.id_currency);
            } else {
                console.warn("Réponse inattendue de l'API :", res.data);
            }
            })
            .catch((err) => {
            console.error("Erreur lors de l'appel à l'API :", err);
            });

        getPriceDollar();
        getPricePub();
        //country
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/country/list`)
     .then(response => {setCountries(response.data.data)})
     //.then(response => console.log(response.data.data))
     .catch(err => console.log(err))

     //adresse
     axios.get(`${process.env.REACT_APP_BASE_URL}/api/utilisateur/adresse/${data?.azId}`)
     .then(response => {
       setAddress(response.data.data)
   })
     .catch(err => console.log(err))

    //  const sessionId = localStorage.getItem('sessionId');
    //  if(sessionId){
    //      getPaymentStatus(sessionId).then(response => {
    //          //console.log(response.data)
    //          if (response.data.status === 'succeeded') {
    //              handlePopupStripeSuccess();
                 
    //          }
    //          }).catch(error => {
    //              console.error('Erreur lors de la récupération du statut de paiement:', error);
    //      });
    //  }
     localStorage.removeItem('sessionId');

        const timer = setTimeout(() => {
            // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
            setLoading(false);
        }, 2000); // 5000 millisecondes = 5 secondes

        // Nettoyer le timer si le composant est démonté avant la fin du délai
        return () => clearTimeout(timer);
    }, []);

     useEffect(()=>{
          if(localStorage.getItem("paymentIdAz"))
          {
             submitForm();
          }
          localStorage.removeItem('formData');
      },[])

    let savedCode = localStorage.getItem('code') ? localStorage.getItem('code') : localStorage.getItem('is_code');
    let savedProvince = localStorage.getItem('province')
    let savedVille =localStorage.getItem('ville');


     useEffect(() => {
        if (savedCode) {
           // setCode(savedCode);
           setFormData({
            ...formData,
            country: savedCode,
            province: savedProvince,
            ville: savedVille
        });
            axios.get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${savedCode}`)
            .then(response => {
                setProvinces(response.data.data)
                })
            .catch(err => console.log(err))

            axios.get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${savedProvince}`)
            .then(response => {
                setCities(response.data.data);
            })
            .catch(err => console.log(err));
        }
    }, [savedCode]); 

      useEffect(() => {
        if (curr) {
    
          setOptions({
            id_currency: curr.id_currency,
            success_url: window.location.origin ,
            cancel_url: window.location.href,
            amount:totalPaid,
            customer: {
              id: data.azId,
              first_name: data.userLastname ?? '',
              last_name: data.userName ?? '',
              email: data.userMail,
              phone: data.userTel,
              code_country: 'BJ'
            },
            seller_number: 1
          });
        }
      }, [curr,totalPaid]);

    const today = new Date().toISOString().split("T")[0]
     const {t} = useTranslation()
     const lang = localStorage.getItem("langague");

     

    return (
        <div className='flex flex-row bg-[#eeee]'>
            {loading ? (
                // Afficher le spinner tant que loading est true
                <Loading />
            ) : (
                <>
                    {/* sidebar left */}

                    <div className='w-screen h-screen barre_scroll'>
                        {/* navbar top orange */}
                        <SidebarTop />
                        {/* navbar top gris*/}
                        <div className='bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]'>
                            <Breadcrumbs >
                                <Link to="" className="opacity-60 md:text-base s:text-xs">
                                    {t("Mes publications")}
                                </Link>
                                <Link to="" className="opacity-60 md:text-base s:text-xs">
                                   {t("Loisirs et Activités")}
                                </Link>
                                <Link to="" className='md:text-base s:text-xs'>
                                    {t("Ajouter")} 
                                </Link>
                            </Breadcrumbs>
                        </div>

                        <div>
                            <ToastContainer />
                        </div>

                        <Link to="/Dashboard/Publications/Loisirs_activites/Voir_des_activites">
                            <div className='flex flex-row items-center space-x-2 relative top-8 s:left-5 sm:left-12 w-[280px]'>
                                <GoArrowLeft className='text-[#fe7f2d]  text-lg' />
                                <p>{t("Retour à la page précedente")}</p>
                            </div>
                        </Link>
                        {/* container formulaire */}
                        <div className='flex justify-center py-20 '>
                            <form onSubmit={handleSubmit} className='flex flex-col space-y-3 '>

                                <div className='bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-6 '>
                                    {/* Ajout des images */}
                                    <div className='flex flex-col space-y-3'>
                                        <div className='flex flex-row items-center space-x-2'>
                                            <MdOutlineAddPhotoAlternate className='text-xl text-[#fe7f2d]' />
                                            <label> {t("Ajouter des images")} <span className='text-red-600'>*</span> </label>
                                        </div>
                                        <input 
                                            type="file" 
                                            accept="image/*" 
                                            onChange={handleInputChange}  
                                            multiple 
                                            id="photo" 
                                            name="photo" 
                                            className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 ' 
                                        />
                                        {errors.photo && Array.isArray(errors.photo) && (
                                            <div>
                                                {errors.photo.map((error, index) => (
                                                    <p key={index} className='text-red-500'>{error}</p>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    {/* Nom du site */}
                                    <div className='flex flex-col space-y-3'>
                                        <div className='flex flex-row items-center space-x-2'>
                                            <MdOutlineHomeWork className='text-xl text-[#fe7f2d]' />
                                            <label>{t("Nom du site")} <span className='text-red-600'>*</span> </label>
                                        </div>
                                        <input type='text' onChange={handleInputChange}  name='nom' placeholder='Ex : Les cascade de Man' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded' />
                                        {errors.nom && <p className='text-red-500'>{errors.nom}</p> }
                                    </div>

                                    <div className='flex flex-col space-y-3'>
                                        <div className='flex flex-row items-center space-x-2'>
                                            <MdOutlinePayment className='text-xl text-[#fe7f2d]' />
                                            <label>{t("Tarif du billet")} <span className='text-red-600'>*</span> </label>
                                        </div>
                                        <input onChange={handleInputChange}  name='tarif' type='number' placeholder='Ex : 10000' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded' />
                                        {errors.prix && <p className='text-red-500'>{errors.prix}</p> }
                                    </div>
                                    
                                  {/* Description */}
                                    <div className='flex flex-col space-y-3'>
                                        <div className='flex flex-row items-center space-x-2'>
                                            <AiOutlineEdit className='text-xl text-[#fe7f2d]' />
                                            <label>{t("Description")} <span className='text-red-600'>*</span> </label>
                                        </div>
                                        <textarea onChange={handleInputChange} name='msg'  className='xs:w-[500px] s:w-[230px] sm:w-[300px] rounded p-2 h-[200px]'></textarea>
                                        {errors.desc && <p className='text-red-500'>{errors.desc}</p> }  
                                    </div>
                                </div>

                                <div className='bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 '>
                                    {/* Tel */}
                                    <div className='flex flex-col space-y-3'>
                                        <div className='flex flex-row items-center space-x-2'>
                                            <FaPhoneAlt className=' text-[#fe7f2d]' />
                                            <label>{t("Telephone")} <span className='text-red-600'>*</span></label>
                                        </div>
                                        <input type='tel' defaultValue={data.userTel} name='phone'  onChange={handleInputChange} placeholder="Ex : +225 xxx xxx xxxx " className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded' />
                                        {errors.tel && <p className='text-red-500'>{errors.tel}</p> }
                                    </div>
                                    {/* Mail */}
                                    <div className='flex flex-col space-y-3'>
                                        <div className='flex flex-row items-center space-x-2'>
                                            <IoIosMail className=' text-[#fe7f2d]' />
                                            <label>{t("Adresse e-mail")} <span className='text-red-600'>*</span></label>
                                        </div>
                                        <input defaultValue={data.userMail} type='email' name='mail'  onChange={handleInputChange} placeholder="Ex : info@monbonsejour.com " className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded' />
                                        {errors.mail && <p className='text-red-500'>{errors.mail}</p> }
                                    </div>
                                    {/* Country */}
                                    <div className='flex flex-col space-y-3'>
                                        <div className='flex flex-row items-center space-x-2'>
                                            <IoMdPin className=' text-[#fe7f2d]' />
                                            <label>{t("Pays")} <span className='text-red-600'>*</span></label>
                                        </div>
                                            
                                        <Form.Group>
                                                <Select
                                                    onChange={handleCountryChange}
                                                    name="country"  
                                                    value={savedCode ? { 
                                                            label: lang === 'fr' ? countries.find(pay => pay?.code === savedCode)?.fr_Name
                                                            : countries.find(pay => pay?.code === savedCode)?.Name , 
                                                            value: savedCode } : null} // Inclut la propriété value
                                                    options={countries.map(pay => ({
                                                        label: lang === 'fr' ? pay?.fr_Name : pay?.Name,
                                                        value: pay?.code
                                                    }))}
                                                    className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                                                />
                                        </Form.Group>

                                        {/* <select onChange={handleCountryChange}  name='country' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                                        <option value={address.code}>{address.fr_Name}</option>
                                                            {countries.map((option, index) => (
                                            <option key={index} value={option.code}>{option.fr_Name}</option>
                                            ))}    
                                        </select> */}
                                        {errors.pays && <p className='text-red-500'>{errors.pays}</p> }
                                    </div>
                                    {/* Province */}
                                    <div className='flex flex-col space-y-3'>
                                        <div className='flex flex-row items-center space-x-2'>
                                            <IoMdPin className=' text-[#fe7f2d]' />
                                            <label>{t("Province")} <span className='text-red-600'>*</span></label>
                                        </div>
                                        <Form.Group>
                                                <Select
                                                    onChange={handleProvinceChange}
                                                    name="province"  
                                                    value={savedProvince ? { 
                                                           label: lang === 'fr' ? provinces.find(prov => prov?.code_province === localStorage.getItem('province'))?.fr_Name
                                                           : provinces.find(prov => prov?.code_province === localStorage.getItem('province'))?.Name, 
                                                           value: savedProvince} : null} // Inclut la propriété value
                                                    options={provinces.map(prov => ({
                                                        label: lang === 'fr' ? prov?.fr_Name : prov?.Name ,
                                                        value: prov?.code_province
                                                    }))}
                                                    className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                                                />
                                        </Form.Group>

                                        {/* <select onChange={handleProvinceChange}  name='province' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                                        <option value={address.code_province}>{address.pname}</option>
                                                            {provinces.map((option, index) => (
                                            <option key={index} value={option.code_province}>{option.fr_Name}</option>
                                            ))}                                   
                                        </select> */}
                                        {errors.province && <p className='text-red-500'>{errors.province}</p> }
                                    </div>
                                    {/* Ville */}
                                    <div className='flex flex-col space-y-3'>
                                        <div className='flex flex-row items-center space-x-2'>
                                            <IoMdPin className=' text-[#fe7f2d]' />
                                            <label>{t("Ville")} <span className='text-red-600'>*</span></label>
                                        </div>
                                        <Form.Group>
                                                <Select
                                                    onChange={handleCityChange}
                                                    name="ville"  
                                                    value={savedVille ? { 
                                                           label: lang === 'fr' ? cities.find(city => city?.code_city === savedVille)?.fr_Name
                                                            : cities.find(city => city?.code_city === savedVille)?.Name,
                                                             value: savedVille} : null} // Inclut la propriété value
                                                    options={cities.map(city => ({
                                                        label: city?.fr_Name,
                                                        value: city?.code_city
                                                    }))}
                                                    className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                                                />
                                        </Form.Group>
                                        {/* <select onChange={handleInputChange}  name='ville' className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4'>
                                        <option value={address.code_city}>{address.cname}</option>
                                                            {cities.map((option, index) => (
                                            <option key={index} value={option.code_city}>{option.fr_Name}</option>
                                            ))}
                                        </select> */}
                                        {errors.ville && <p className='text-red-500'>{errors.ville}</p> }
                                    </div>
                                    {/* Lieu */}
                                    <div className='flex flex-col space-y-3'>
                                        <div className='flex flex-row items-center space-x-2'>
                                            <IoMdPin className=' text-[#fe7f2d]' />
                                            <label>{t("Lieu")} <span className='text-red-600'>*</span></label>
                                        </div>
                                        <input defaultValue={address.Adresses} type='text' name='lieu' onChange={handleInputChange} placeholder="Ex : Cocody, Abidjan, Côte d'ivoire " className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded' />
                                        {errors.adresse && <p className='text-red-500'>{errors.adresse}</p> }
                                    </div>
                                </div>

                                <div className='bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 '>
                                {/* date debut */}
                                <div className='flex flex-col space-y-3'>
                                    <div className='flex flex-row items-center space-x-2'>
                                        <CiCalendarDate className=' text-[#fe7f2d]' />
                                        <label>{t("Date de debut affichage")} <span className='text-red-600'>*</span></label>
                                    </div>
                                    <input name='date_debut' onChange={handleInputChange} type='date'
                                          className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded'
                                          min={ today}
                                           />
                                    {errors.date_debut && <p className='text-red-500'>{errors.date_debut}</p> }
                                </div>

                                {/* date fin */}
                                <div className='flex flex-col space-y-3'>
                                    <div className='flex flex-row items-center space-x-2'>
                                        <CiCalendarDate className=' text-[#fe7f2d]' />
                                        <label>{t("Date de fin affichage")} <span className='text-red-600'>*</span></label>
                                    </div>
                                    <input name='date_fin' onChange={handleInputChange} type='date'
                                          className='xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded'
                                          min={today}
                                            />
                                    {errors.date_fin && <p className='text-red-500'>{errors.date_fin}</p> }
                                </div>

                                {totalPaid !== 0 && !isNaN(totalPaid) &&(
                                    
                                    <div className='flex flex-col items-center mx-2 space-y-3 text-center '>
                                        <div className='flex flex-row items-center space-x-2 bg-[#1F2937] h-10 rounded'>
                                            <GiMoneyStack className='text-xl text-white' />                  
                                            <label className='text-white w-[250px] text-bold'>{t("Montant total")}: {totalPaid} F CFA</label>
                                        </div>
                                    </div>
                                )  
                                }
                            
                            </div>
                            {(totalPaid !== 0 && !isNaN(totalPaid)) ?
                                        <button className='bg-[#FCCA46] w-[250px] h-10 rounded
                                        text-white'>{t("Procéder au paiement")}</button>
                                        :
                                        <button className='bg-[#FCCA46] w-[150px] h-10 rounded
                                        text-white'>{totalPaid === 0 ? t("Ajouter gratuitement"): t("Ajouter")}</button>
                                    }

                                    {/* {showPopup && (
                                        <PaymentPopup
                                            open={showPopup}
                                            montant={parseFloat(pricePub) * Math.ceil((new Date(formData.date_fin) - new Date(formData.date_debut)) / (1000 * 60 * 60 * 24))}
                                            onSuccess={handlePopupSuccess}
                                            userNom={data.userLastname}
                                            userPrenom={data.userName                    }
                                            email={data.userMail}
                                            tel={data.userTel}
                                            user_Id={data.userId}
                                            dollarP={Math.round(priceD)}
                                            onCancel={handlePopupCancel}
                                        />
                                    )} */}


                                {/* <button className='bg-[#FCCA46] w-[150px] h-10 rounded text-white'>Ajouter</button> */}
                            </form>

                                {
                                        open && (
                                        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                                            <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                                                {/* Bouton de fermeture à l'intérieur du modal */}
                                                <button
                                                onClick={() => setOpen(false)}
                                                className="absolute top-3 right-3 text-red-500 text-2xl"
                                            >
                                                &times;
                                            </button>
                                                <Create item="Rechargement de la carte AZ"  options={options} onSuccess={submitForm} ></Create>
                                            </div>
                                        </div>
                                        )
                                    }
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default AjoutLoisir